import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function PhotoGallery({ data }) {
    const [previousAlbumsPage, setPreviousAlbumsPage] = useState();

    function showOrHideAlbumsPage(pageNum, show) {
        let pageToShow = document.getElementsByClassName("page_" + pageNum);
        for (let i = 0; i < pageToShow.length; i++) {
            if (show) {
                pageToShow[i].style.display = "block";
            } else {
                pageToShow[i].style.display = "none";
            }
        }
    }

    function switchAlbumsPage(pageNumber) {
        if (previousAlbumsPage) {
            if (pageNumber === previousAlbumsPage) {
                return false;
            }
            showOrHideAlbumsPage(previousAlbumsPage, false);
            showOrHideAlbumsPage(pageNumber, true);
        } else {
            showOrHideAlbumsPage(pageNumber, true);
            window.jQuery("#pager_" + pageNumber).addClass("active_page");
        }
        if (window.jQuery("#pager_" + previousAlbumsPage).hasClass("active_page")) {
            window.jQuery("#pager_" + previousAlbumsPage).removeClass("active_page");
            window.jQuery("#pager_" + pageNumber).addClass("active_page");
        }
        setPreviousAlbumsPage(pageNumber);
    }

    const switchAlbumsPageAndSuppressEvent = (e, pageNumber) => {
        e.preventDefault();
        switchAlbumsPage(pageNumber);
    };

    useEffect(() => {
        // Ensure jQuery is loaded before using it
        if (window.jQuery) {
            window.jQuery(document).ready(function() {
                switchAlbumsPage(1);
            });
        }
    }, []);

    const pageListElements = [];
    for (let i = 1; i < Math.ceil( data.albums.length / 4 ) + 1; i++) {
        pageListElements.push(
            <li key={ i } className="page-item">
                <a href="" onClick={ (e) => switchAlbumsPageAndSuppressEvent(e, i) } className="page-link" id={ "pager_" + i }>{ i }</a>
            </li>
        );
    }

    return (
        <div key={data.documentId} className="photo-gallery full-width light-gray-background">
            <div className="views-row views-row-1 views-row-odd views-row-first">

                <article id="node-22" className="node node-photo-gallery node-promoted node-teaser contextual-links-region clearfix" about="/node/22" typeof="sioc:Item foaf:Document">

                <div className="container-fluid photo-div background-full-width light-gray-background" style={{ margin: "0 -15px" }} id="photoGallery">
                    <div className="row" style={{ maxWidth: "1230px", margin: "0 auto" }}>
                        <div className="row">

                            <h2 className="section-headline-small">
                                PHOTOS
                            </h2>
                            <hr style={{ borderTop: "2px solid #333" }} />
                            {/*previous color    #c9cacb*/}
                        </div>

                        <div className="modal fade" id="albumModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                        <h4 className="modal-title" id="myModalLabel">Photos</h4>
                                    </div>
                                    <div className="modal-body center-align">
                                        <img alt="modal-img" className="" src="https://www.cleanairpartners.net/media-center" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="">
                                <h2 className="section-headline-small">
                                    Albums
                                </h2>
                            </div>
                            <div className="container-fluid album-container no-padding">

                                {data.albums.map((album, albumIdx) => (
                                    <div key={ albumIdx } className={ "col-sm-3 col-sm-offset-0 col-xs-10 col-xs-offset-1 album-div no-padding page_" + Math.ceil( (albumIdx+1) / 4 ) } style={{width:'100%'}}>
                                        <div className="album-preview" style={{width: '100%', overflow:'hidden'}}>
                                            <a href={ album.album.photo_album_item.preview.url } data-lightbox={ "image-" + album.album.photo_album_item.name.replaceAll(" ", "_") }>
                                                <img alt="album-preview" className="img-responsive preview-img" src={ album.album.photo_album_item.preview.url } style={{maxWidth: '100%'}}/>
                                            </a>

                                            {album.album.photo_album_item.photos.map((photo, photoIdx) => (
                                                <a key={ photoIdx } href={ photo.url } data-lightbox={ "image-" + album.album.photo_album_item.name.replaceAll(" ", "_") }></a>
                                            ))}
                                        </div>


                                        <p className="body-text" align="left" style={{ margin: "0 auto", maxWidth: "97%", overflow: 'wrap', marginLeft:'-0.25%'}}>
                                            { album.album.photo_album_item.name }
                                        </p>
                                        <p style={{ fontSize: "12px", paddingTop: "10px" }}>
                                            { album.album.photo_album_item.date } &nbsp; | &nbsp; { album.album.photo_album_item.location }
                                        </p>

                                    </div>
                                ))}

                            </div>

                            <div className="col-xs-12 center-align clearfix" style={{display: 'flex', justifyContent: 'center'}}>
                                <nav aria-label="Page navigation" className="clearfix">
                                    <ul className="pagination clearfix">
                                        { pageListElements }
                                    </ul>
                                </nav>
                            </div>

                        </div>

                    </div>
                </div>

                </article>

            </div>
        </div>
    );
}

export default PhotoGallery;
